import { classNames } from '../../utils/helper'

const SelectItem = ({
    label,
    options,
    id,
    className,
    onChange,
    setSelected,
    value,
    noEmptySelect,
    ...props
}) => {
    if (!options) return <></>

    return (
        <div className="w-full flex items-center justify-between border-grey-300 mb-4 min-h-[43px]">
            {label && (
                <label htmlFor={id} className="text-label uppercase ">
                    {label}
                </label>
            )}
            <select
                {...props}
                className={classNames(
                    className,
                    'leading-[18px] text-grey-100 focus:outline-primary icon-select px-4 form-item min-h-[39px] h-fit w-7/12 bg-grey-400 text-input'
                )}
                name={id}
                id={id}
                value={value}
                onChange={(e) => {
                    setSelected(e.target.value)
                }}
            >
                {!value && !noEmptySelect && (
                    <option
                        className="text-grey-100 rounded-none focus:rounded-none"
                        key={'select...'}
                        value={''}
                    >
                        Select...
                    </option>
                )}
                {options.map(({ value, label }) => (
                    <option
                        className="text-grey-100 rounded-none focus:rounded-none"
                        key={value}
                        value={value}
                    >
                        {label}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default SelectItem
